import Image from "next/image";
import { solutionList } from "./constant";

const NavSolutionMenu: React.FC = () => {
    return (
        <section className="w-full mx-auto px-8 bg-white py-10">
            <div className="grid grid-cols-4 gap-5 max-w-7xl mx-auto px-5">
                {solutionList.map((value) => (
                    <div key={value.featureTitle} className={value.featureTitle === "Industry" ? "col-span-2" : ""}>
                        <div className="font-bold text-xl uppercase pb-5">{value.featureTitle}</div>
                        <hr style={{ borderTop: "1px solid #CBD5E0" }} className={value.featureTitle === "Industry" ? "pt-3" : "w-64 pt-3"} />

                        <div className={value.featureTitle === "Industry" ? "grid grid-cols-2 gap-4" : "space-y-5"}>
                            {value.feature.map((data, index) => (
                                <div className="flex items-start  gap-4 cursor-pointer" key={index}>
                                    {data.image && <Image alt={data.imgAlt ?? ""} src={data.image ?? ""} width={32} height={32} className="pb-3" />}
                                    <div className="font-semibold text-sm pb-2 flex flex-col">
                                        <a href={data.link} className=" pb-2 ">
                                            {data.title}
                                        </a>
                                        <p className="text-sm font-normal" style={{ width: "90%" }}>
                                            {data.summary}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default NavSolutionMenu;
